import axios from "axios";
import { NewRepository, Repository } from "./repository";
const requestRepo = {
  registerRequest,
};
const resource = "Request";


function registerRequest(payLoad, token) {
  //   let url = 'https://localhost/api/Request/registerRequest';
  //   return Repository(token).post(`${resource}/registerRequest/`, payLoad);
  //  return axios.post(url, 
  //     payLoad
  //   , {
  //     headers: {
  //       "Content-type": "application/json; charset=UTF-8",
  //       "Authorization": 'Bearer ' + token
  //     }
  //   })
  return NewRepository(`${resource}/registerRequest`, payLoad, token);
}
export default requestRepo